export default __webpack_public_path__ + "static/home-page-bio-4-cropped-4-3-aspect-ratio-fcff3931ba3c948dc93ea37426b2c686.webp";